import React from "react";

const IconBell = ({ color = "#e31c19" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <g id="Notification" transform="translate(-14 -14)">
        <g
          id="UI_icon_notification_light"
          data-name="UI icon/notification/light"
          transform="translate(12 12)"
        >
          <path
            id="Union"
            d="M10,20a4,4,0,0,1-4-4H1.4a1.4,1.4,0,0,1-.976-2.414l1.03-.995a2.008,2.008,0,0,0,.61-1.444l-.01-3.153A7.971,7.971,0,1,1,18,7.97v3.2a1.987,1.987,0,0,0,.586,1.414l1,1a1.415,1.415,0,0,1-1,2.415H14A4.005,4.005,0,0,1,10,20ZM8,16a2,2,0,1,0,4,0ZM10.03,2A5.971,5.971,0,0,0,4.059,7.988l.009,3.154A4.021,4.021,0,0,1,2.878,14H17.172A3.975,3.975,0,0,1,16,11.172V7.97A5.977,5.977,0,0,0,10.03,2Z"
            transform="translate(2 2)"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
};

export default IconBell;
